import { render, staticRenderFns } from "./Hexiao.vue?vue&type=template&id=18c01702&scoped=true"
import script from "./Hexiao.vue?vue&type=script&lang=js"
export * from "./Hexiao.vue?vue&type=script&lang=js"
import style0 from "./Hexiao.vue?vue&type=style&index=0&id=18c01702&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c01702",
  null
  
)

export default component.exports